module.exports = __webpack_public_path__ + "static/ammoniti-e6320215ac0eaa873219cfc01e1c6bb2.jpg";